<template>
  <div class="column justify-center items-center q-mt-sm q-mb-lg text-grey-7">
    <q-icon name="search_off" size="xl" />
    <div class="text-h6">No units found</div>
    <div class="text-body2">Please adjust your filters to see results</div>
    <q-btn
      v-if="hasResetFilters"
      class="q-mt-md"
      color="primary"
      no-caps
      unelevated
      outline
      @click="onResetClick"
    >
      Reset Filters
      <q-tooltip max-width="300px">
        Remove your saved filters and reset the view to default filters.
      </q-tooltip>
    </q-btn>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NoUnitsFound',
  inject: {
    resetFilters: { default: null }
  },
  computed: {
    hasResetFilters(): boolean {
      return typeof (this as any).resetFilters === 'function'
    }
  },
  methods: {
    onResetClick(): void {
      ;(this as any).resetFilters?.()
    }
  }
}
</script>

<style scoped></style>
